<template>
  <div class="Pager">
    <div
      class="start"
      :class="value > 0 ? 'pager-button' : 'disabled-pager-button'"
      @click="start" />
    <div
      class="prev"
      :class="value > 0 ? 'pager-button' : 'disabled-pager-button'"
      @click="prev" />
    <div>{{ value + 1 }}/{{ count }}</div>
    <div
      class="next"
      :class="value < count - 1 ? 'pager-button' : 'disabled-pager-button'"
      @click="next" />
    <div
      class="end"
      :class="value < count - 1 ? 'pager-button' : 'disabled-pager-button'"
      @click="end" />
  </div>
</template>

<script>
export default {
  name: "Pager",
  props: {
    value: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    }
  },
  methods: {
    start () {
      if (this.value > 0) {
        this.$emit('input', 0)
        window.scrollTo(0, 0)
      }
    },
    prev () {
      if (this.value > 0) {
        this.$emit('input', this.value - 1)
        window.scrollTo(0, 0)
      }
    },
    next () {
      if (this.value < this.count - 1) {
        this.$emit('input', this.value + 1)
        window.scrollTo(0, 0)
      }
    },
    end () {
      if (this.value < this.count - 1) {
        this.value = this.count - 1
        this.$emit('input', this.value)
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  padding: 10px 30px;
  background-color: #E5E3E5;
  font-size: 12px;
  color: #8D7F81;
}
.pager-button {
  width: 20px;
  height: 16px;
  background-size: contain;
  background-position: center;
  &.start, 
  &.end { background-image: url(../assets/Png/Common/ic_arrow_pager_2.png); }
  &.prev, 
  &.next { background-image: url(../assets/Png/Common/ic_arrow_pager_1.png); }
  &.start,
  &.prev { transform: rotate(180deg); }
}
.disabled-pager-button {
  width: 20px;
  height: 16px;
  background-image: url(../assets/Png/Common/ic_arrow_pager_2_disabled.png);
  background-size: contain;
  background-position: center;
  &.start, 
  &.end { background-image: url(../assets/Png/Common/ic_arrow_pager_2_disabled.png); }
  &.prev, 
  &.next { background-image: url(../assets/Png/Common/ic_arrow_pager_1_disabled.png); }
  &.start,
  &.prev { transform: rotate(180deg); }
}
.prev {
  transform: rotate(180deg);
}
</style>
